import { Button } from 'components/common/Button';
import s from './Prices.module.scss';
import { Modal } from 'components/common/Modal/Modal';
import { ModalNavigationContext } from 'components/pages/ConsultantPage/ConsultantPage';
import { useTranslation } from 'react-i18next';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { ReactComponent as PaymentHistoryIcon } from 'images/paymentHistory.svg';
import { ReactComponent as RequestsHistoryIcon } from 'images/requestsHistory.svg';
import { TariffSlider } from './components/TariffSlider/TariffSlider';

const icons = {
  paymentHistory: <PaymentHistoryIcon />,
  requestsHistory: <RequestsHistoryIcon />,
};

export const Prices = () => {
  const { t } = useTranslation();
  const { closeRouteModal, goBack } =
    useOutletContext<ModalNavigationContext>();
  const navigate = useNavigate();

  const navigateToPaymentHistory = () => {
    navigate('payment-history');
  };

  const navigateToRequestsHistory = () => {
    navigate('requests-history');
  };

  return (
    <Modal
      title={t('profile.pricesAndOperations.title')}
      onBack={goBack}
      onClose={closeRouteModal}
    >
      <div className={s.container}>
        <div className={s.table}>
          <Button
            className={s.table__btn}
            isRounded={true}
            data-selected={true}
          >
            {t('profile.pricesAndOperations.period.month')}
          </Button>
          <Button
            isRounded={true}
            className={s.table__btn}
            data-selected={false}
          >
            {t('profile.pricesAndOperations.period.monthly')}
          </Button>
          <Button
            isRounded={true}
            className={s.table__btn}
            data-selected={false}
          >
            {t('profile.pricesAndOperations.period.year')}
            <span className={s.table__btn__sale}>(25%)</span>
          </Button>
        </div>

        <TariffSlider />

        <Button className={s.btn} onClick={navigateToPaymentHistory}>
          {icons.paymentHistory}
          {t('profile.pricesAndOperations.paymentHistory')}
        </Button>
        <Button className={s.btn} onClick={navigateToRequestsHistory}>
          {icons.requestsHistory}
          {t('profile.pricesAndOperations.requestsHistory')}
        </Button>
      </div>
    </Modal>
  );
};
